import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useTheme } from '@mui/material';
import { toast } from 'react-toastify';

import { FormWrapper, Loading, TopBorderPaper } from 'components';
import { ROUTES } from 'consts';
import { useQueryValues } from 'hooks/url.hook';
import { useAuthVerifyEmailQuery } from 'store/apis/auth.api';
import { userApi } from 'store/apis/user.api';
import { useAppDispatch } from 'store/store.hook';

interface VerificationConfirmPageProps {}

export const VerificationConfirmPage: React.FC<VerificationConfirmPageProps> = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const { link } = useQueryValues(['link']);
  const [skipVerifyEmail, setSkipVerifyEmail] = React.useState<boolean>(true);
  const { isLoading, isSuccess, isError } = useAuthVerifyEmailQuery({ link }, { skip: skipVerifyEmail });

  React.useEffect(() => {
    if (!link) {
      navigate(`/${ROUTES.VERIFICATION}/${ROUTES.VERIFICATION_REQUEST}`);
    } else {
      setSkipVerifyEmail(false);
    }
  }, [link]);

  React.useEffect(() => {
    if (isError) {
      toast.error('Your email address could not be verified.');
      navigate(`/${ROUTES.VERIFICATION}/${ROUTES.VERIFICATION_REQUEST}`);
    } else if (!isLoading && isSuccess) {
      dispatch(userApi.endpoints.fetchUser.initiate());
    }
  }, [isLoading, isSuccess, isError]);

  return (
    <Box sx={{ paddingX: 2, paddingTop: 3, paddingBottom: 8 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', padding: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 400 }}>
        <Box sx={{ width: '100%', maxWidth: theme.breakpoints.values.sm, position: 'relative' }}>
          <TopBorderPaper>
            <FormWrapper
              sx={{
                [theme.breakpoints.up('md')]: {
                  paddingX: 6,
                  paddingY: 8,
                },
                [theme.breakpoints.up('lg')]: {
                  paddingX: 8,
                  paddingY: 8,
                },
              }}
            >
              <Typography variant="h5" sx={{ textAlign: 'center' }}>
                Verifying your request
              </Typography>

              <Typography color="textSecondary" sx={{ marginTop: 4, textAlign: 'center' }}>
                Please wait while your request is being verified.
              </Typography>

              <Loading text="" />
            </FormWrapper>
          </TopBorderPaper>
        </Box>
      </Box>
    </Box>
  );
};
